
import axios from 'axios';
import { baseUrl } from '@helpers/functions';
import { processPromise } from '@helpers/functions';

const dashboard = {};

dashboard.details = (token) => {
  const endpoint = `${baseUrl('', 'api')}/report/${token}`;

  return axios.get(endpoint).then(result => {
    return processPromise(true, result);
  }).catch((error) => {
    processPromise(false, error)
  });
}

export default dashboard
